import { render } from "./ProfileBottomPopUp.vue?vue&type=template&id=c3578e5a&scoped=true&ts=true"
import script from "./ProfileBottomPopUp.vue?vue&type=script&lang=ts"
export * from "./ProfileBottomPopUp.vue?vue&type=script&lang=ts"

import "./ProfileBottomPopUp.vue?vue&type=style&index=0&id=c3578e5a&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3578e5a"]])

export default __exports__